/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_PasteInputs */

const en_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const fr_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller`)
};

const de_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const it_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impasto`)
};

const ru_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить`)
};

const es_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta`)
};

const zh_cn2_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴`)
};

const ja_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペースト`)
};

const hi_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट करें`)
};

const pt_pt2_context_menu_paste = /** @type {(inputs: Context_Menu_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar`)
};

/**
* | output |
* | --- |
* | "Paste" |
*
* @param {Context_Menu_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste = /** @type {((inputs?: Context_Menu_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_paste(inputs)
	if (locale === "de") return de_context_menu_paste(inputs)
	if (locale === "it") return it_context_menu_paste(inputs)
	if (locale === "ru") return ru_context_menu_paste(inputs)
	if (locale === "es") return es_context_menu_paste(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_paste(inputs)
	if (locale === "ja") return ja_context_menu_paste(inputs)
	if (locale === "hi") return hi_context_menu_paste(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_paste(inputs)
	return en_context_menu_paste(inputs)
});